var render = function render(){var _vm=this,_c=_vm._self._c;return _c('site-header',{on:{"auth-updated":function($event){return _vm.$emit('auth-updated')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }